import React, { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import {FiShoppingBag, FiGift} from "react-icons/fi";
import {GiPayMoney} from "react-icons/gi";
import {MdSecurity} from "react-icons/md";
import {FcOnlineSupport} from "react-icons/fc";
import Marquee from "react-fast-marquee";
import BlogCard from '../ass_components/BlogCard';
import ProductCard from '../ass_components/ProductCard';
import EquipmentCard from '../ass_components/EquipmentCard';
import MeilleursVentes from '../ass_components/MeilleursVentes';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../i18n';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppDownloadSection from '../ass_components/AppDownloadSection';
import { countryAssets } from '../config/countryAssets';
import {Button} from "antd";
import {
    AppstoreOutlined,
    UpOutlined,
    DownOutlined
} from "@ant-design/icons";


const Home = () => {
    const [showAllCategories, setShowAllCategories] =
        useState(false);
    const country = useSelector((state) => state.country.country);
    const countryCode = country?.value || "FR"; // fallback

    // Only West African Countries
    const DeployedAfricaCountryCodes = [
        'BJ', // Benin
        //'BF',  Burkina Faso
        //'CV', // Cape Verde
        'CI', // Côte d'Ivoire
        //'GM', // Gambia
        'GH', // Ghana
        //'GN', // Guinea
        //'GW',  //Guinea-Bissau
        //'LR', // Liberia
        //'ML', // Mali
        //'MR',  // Mauritania
        //'NE', // Niger
        'NG', // Nigeria
        'SN', // Senegal
        //'SL',  // Sierra Leone
        'TG',  // Togo
        'CM', // Cameroon
        //'MA',
        //'ZA'
    ];

    const assets = (
        countryCode &&
        DeployedAfricaCountryCodes.includes(countryCode) &&
        countryAssets[countryCode]
    )
        ? countryAssets[countryCode]
        : countryAssets.DEFAULT;

    const mainBanners = (assets.mainBanner || []).filter(Boolean);

    const [currentBannerIndex, setCurrentBannerIndex] = useState(0);

    useEffect(() => {

        if (mainBanners.length <= 1) return;

        const interval = setInterval(() => {
            setCurrentBannerIndex((prev) =>
                (prev + 1) % mainBanners.length
            );
        }, 9000);

        return () => clearInterval(interval);

    }, [mainBanners.length]);

    useEffect(() => {

        mainBanners.forEach((banner) => {
            const img = new Image();
            img.src = `/${banner}`;
        });

    }, [mainBanners]);

    const [feedback, setFeedback] = useState({ message: '', type: '' });
  const dispatch = useDispatch();
  const language_code = useSelector((state) => state.lang)


  const [user, setUser] = useState(null);
  let productCardProps=[
    { id:1,
      image1:'images/detail-images/detail1.jpg',
      image2:'images/detail-images/detail111.jpg',
      product_title:'Soja alvic',
      star_number:4,
      price:'300',
    },
    { id:2,
      image1:'images/detail-images/detail22.webp',
      image2:'images/detail-images/detail2.jpg',
      product_title:'Pomme de terre',
      star_number:4,
      price:'250',
    },
    { id:3,
      image1:'images/detail-images/detail3.webp',
      image2:'images/detail-images/detail33.jpeg',
      product_title:'Fruits et legumes',
      star_number:4,
      price:'400',
    },
    { id:4,
      image1:'images/detail-images/detail4.jpg',
      image2:'images/detail-images/detail44.webp',
      product_title:'Patate douce',
      star_number:4,
      price:'300',
    }
  ]

  let meilleursVenteCardProps=[
    { id:1,
      image1:'images/bestseller-images/bestseller1.webp',
      product_category:'Grains',
      product_title:'Riz long',
      progress_bar:'75',
      star_number:5,
      price:'200FCFA/Kg',
      actual_price:650,
      days:1,
      in_stock:'50 tonnes',
      farmers_number:12
    },
    { id:2,
      image1:'images/bestseller-images/bestseller8.jpg',
      product_category:'Grains',
      product_title:'Maïs nouveau',
      progress_bar:'50',
      star_number:4,
      price:'250FCFA/Kg',
      actual_price:650,
      days:3,
      in_stock:'80 tonnes',
      farmers_number:21
    },
    { id:3,
      image1:'images/bestseller-images/bestseller4.jpg',
      product_category:'Fruits',
      product_title:'Ananas',
      progress_bar:'75',
      star_number:5,
      price:'300FCFA/Kg',
      actual_price:650,
      days:2,
      in_stock:'12 tonnes',
      farmers_number:13
    }
  ]

  let blogCardProps=[
    { id:1,
      image:'images/blog-images/delivery1.jpg',
      blog_category:'Grains',
      blog_title:'Livraison 24/72h en moyenne',
      blog_description:"Nos articles sont en cours de révision. Le service de newsletter vous tient au courants des échances futures jusqu'en Septembre. De là vous retrouverez toutes nos publications en ligne à nouveau...",
      publish_date:'12/06/23',
      likes:650,
      views:254,
      update_date:'12/06/23'
    },
    { id:2,
      image:'images/blog-images/security1.png',
      blog_category:'Grains',
      blog_title:'Payement 100% securise en ligne',
      blog_description:"Nos articles sont en cours de révision. Le service de newsletter vous tient au courants des échances futures jusqu'en Septembre. De là vous retrouverez toutes nos publications en ligne à nouveau...",
      publish_date:'12/06/23',
      likes:650,
      views:254,
      update_date:'12/06/23'
    },
    { id:3,
      image:'images/blog-images/quality1.jpg',
      blog_category:'Grains',
      blog_title:'6000 produits de qualite PRO',
      blog_description:"Nos articles sont en cours de révision. Le service de newsletter vous tient au courants des échances futures jusqu'en Septembre. De là vous retrouverez toutes nos publications en ligne à nouveau...",
      publish_date:'12/06/23',
      likes:650,
      views:254,
      update_date:'12/06/23'
    },
    { id:4,
      image:'images/blog-images/collectivity1.png',
      blog_category:'Grains',
      blog_title:'Particulier, Pro & Collectivite',
      blog_description:"Nos articles sont en cours de révision. Le service de newsletter vous tient au courants des échances futures jusqu'en Septembre. De là vous retrouverez toutes nos publications en ligne à nouveau...",
      publish_date:'12/06/23',
      likes:650,
      views:254,
      update_date:'12/06/23'
    }
  ]
  
  const equipmentList = [
  {
    id: "debroussailleuse",
    title: "tête de débroussailleuse",
    subtitle: "multifils-attilina",
    price: "8000 FCFA HT",
    image: "images/equipment-images/tete-de-debroussailleuse-multifils-attilina.jpg"
  },
  {
    id: "fil-debroussaillage",
    title: "fil de débroussaillage",
    subtitle: "pro ellipse bruit",
    price: "9000 FCFA HT",
    image: "images/equipment-images/fil-de-debroussaillage-pro-ellipse-bruit-reduit-25mm-vert-et-noir-blister-de-65m.jpg"
  },
  {
    id: "piquet-de-vigne",
    title: "piquet de vigne",
    subtitle: "intermédiaire",
    price: "11500 FCFA",
    image: "images/equipment-images/piquet-vigne-intermediaire-encoches-lonneo-e01-galva-z275-ep-15-mm-long-180-m-lot-200-unites.jpg"
  },
  {
    id: "ultrason-solaire",
    title: "ultrason solaire",
    subtitle: "répulsif de gibier",
    price: "11500 FCFA",
    image: "images/equipment-images/repulsif-gibier-ultrason-solaire-doxmand-dual-surface-couverte-2-ha.jpg"
  }
  ];

  
  return (<>
        <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
        />
    <section className='assiganto-home-wrapper-1 py-4'>
      <div className='container-xxl'>
        <div className='row'>
          <div className='col-6'>
            <div className='main-banner position-relative'>
                <img
                    src={`/${mainBanners[currentBannerIndex]}`}
                    className="img-fluid vedette rounded-3 fade-banner"
                    alt="main-banner"
                />
               <div className='main-banner-content position-absolute'>
                <h5>{translate('main_banner', language_code.lang).main_banner_title}</h5>
                <h4>{translate('main_banner', language_code.lang).main_banner_subtitle}</h4>
                <p>{translate('main_banner', language_code.lang).main_banner_domain}
                <br/>{translate('main_banner', language_code.lang).main_banner_spec}</p>
                <Link className='button' to='/signup'>{translate('main_banner', language_code.lang).main_banner_signin}</Link>
              </div>
            </div>            
          </div>  
          <div className='col-6'>
            <div className='d-flex flex-wrap gap-10 justify-content-center align-items-center'>
            <div className='small-banner position-relative'>
                <Link
                    to="/catalog/category/TUBER"
                    style={{
                        textDecoration: "none"
                    }}
                >
                <img src="images/presentation_images/vedette1.png"
                   className="img-fluid rounded-3" 
                   alt="small-banner"/>
                </Link>
              <div className='small-banner-content position-absolute'>
                <h4>{translate('small-banner1', language_code.lang).main_banner_title}</h4>
                <h5>{translate('small-banner1', language_code.lang).main_banner_subtitle}</h5>
                <p>{translate('small-banner1', language_code.lang).main_banner_domain} <br/>
                {translate('small-banner1', language_code.lang).main_banner_spec}</p>
              </div>
            </div>

            <div className='small-banner position-relative'>
                <Link
                    to="/search?type=products&category=RAW_MATERIAL"
                    style={{
                        textDecoration: "none"
                    }}
                >
              <img src="images/presentation_images/vedette2.png" 
                   className="img-fluid rounded-3" 
                   alt="small-banner"/>
                </Link>
              <div className='small-banner-content position-absolute'>
              <h4>{translate('small-banner2', language_code.lang).main_banner_title}</h4>
                <h5>{translate('small-banner2', language_code.lang).main_banner_subtitle}</h5>
                <p>{translate('small-banner2', language_code.lang).main_banner_domain} <br/>
                {translate('small-banner2', language_code.lang).main_banner_spec}</p>
              </div>
            </div>
            <div className='small-banner position-relative'>
                <Link
                    to="/catalog/category/LEGUME"
                    style={{
                        textDecoration: "none"
                    }}
                >
              <img src="images/presentation_images/vedette3.png" 
                   className="img-fluid rounded-3" 
                   alt="small-banner"/>
                </Link>
              <div className='small-banner-content position-absolute'>
              <h4>{translate('small-banner3', language_code.lang).main_banner_title}</h4>
                <h5>{translate('small-banner3', language_code.lang).main_banner_subtitle}</h5>
                <p>{translate('small-banner3', language_code.lang).main_banner_domain} <br/>
                {translate('small-banner3', language_code.lang).main_banner_spec}</p>
              </div> 
            </div>  
            <div className='small-banner position-relative'>
                <Link
                    to="/catalog/category/CEREAL"
                    style={{
                        textDecoration: "none"
                    }}
                >
              <img src="images/presentation_images/vedette4.png"
                   className="img-fluid rounded-3" 
                   alt="small-banner"/>
                </Link>
              <div className='small-banner-content position-absolute'>
                <h4>{translate('small-banner4', language_code.lang).main_banner_title}</h4>
                <h5>{translate('small-banner4', language_code.lang).main_banner_subtitle}</h5>
                <p>{translate('small-banner4', language_code.lang).main_banner_domain} <br/>
                {translate('small-banner4', language_code.lang).main_banner_spec}</p>
              </div> 
            </div>
            </div>
          </div>         
        </div>        
      </div>
    </section>


    <section className='assiganto-home-wrapper-2 py-4'>
        {/* ========================= */}
        {/* SECTION HEADER */}
        {/* ========================= */}

        <div
            style={{
                textAlign: "center",
                marginBottom: 40
            }}
        >

    <span
        style={{
            background: "#E8F5E9",
            color: "#2E7D32",
            padding: "8px 18px",
            borderRadius: 30,
            fontWeight: 600,
            fontSize: 14,
            display: "inline-block",
            marginBottom: 16
        }}
    >
        🌍 Marketplace Agricole
    </span>

            <h2
                style={{
                    fontSize: 38,
                    fontWeight: 700,
                    marginBottom: 14,
                    color: "#1F2937"
                }}
            >
                Explorez les produits agricoles disponibles
            </h2>

            <p
                style={{
                    maxWidth: 780,
                    margin: "0 auto",
                    fontSize: 18,
                    lineHeight: 1.8,
                    color: "#6B7280"
                }}
            >
                Parcourez les différentes catégories de produits
                commercialisés par les producteurs de votre pays.
                Comparez les offres disponibles, découvrez les régions
                productrices et contactez les vendeurs via la marketplace.
            </p>

        </div>
      <div className='container-xxl'>
        <div className='row'>
          <div className='col-12'>
            <div className='categories d-flex flex-wrap justify-content-between align-items-center'>

              <div className='d-flex flex-column'>
                <div>
                  <h6>Les céréales</h6>
                <Link className='farmers-link' to={`/catalog/category/CEREAL`}>
                  31 producteurs
                </Link>
                </div>
                <img src='images/specimen-images/cereale4.jpg' className='img-fluid' alt='produits cerealiers' />
              </div>

              <div className='d-flex flex-column'>
                <div>
                  <h6>Les légumineuses</h6>
                  <Link className='farmers-link' to={`/catalog/category/LEGUME`}>
                  54 producteurs
                </Link>
                </div>
                <img src='images/specimen-images/legumes.jpeg' className='img-fluid' alt='legumineuses' />
              </div>

               <div className='d-flex flex-column'>
                    <div>
                        <h6>Epices</h6>
                        <Link className='farmers-link' to={`/catalog/category/SPICE`}>
                            12 producteurs
                        </Link>
                    </div>
                    <img src='images/specimen-images/spices.jpeg'  className='img-fluid' alt='spice' />
               </div>

                <div className='d-flex flex-column'>
                    <div>
                        <h6>Les légumes</h6>
                        <Link className='farmers-link' to={`/catalog/category/VEGETABLE`}>
                            54 producteurs
                        </Link>
                    </div>
                    <img src='images/specimen-images/legume1.jpg' className='img-fluid' alt='legumes' />
                </div>

            </div>
          </div>
        </div>
      </div>
    </section>

      {/* ========================= */}
      {/* BUTTON */}
      {/* ========================= */}

      <div
          style={{
              textAlign: "center",
              marginBottom: 30
          }}
      >

          <Button
              type="primary"
              size="large"
              icon={
                  showAllCategories
                      ? <DownOutlined />
                      : <UpOutlined />
              }

              onClick={() =>

                  setShowAllCategories(
                      !showAllCategories
                  )
              }

              style={{
                  borderRadius: 40,
                  paddingInline: 32,
                  height: 52,
                  fontWeight: 600,
                  fontSize: 16,
                  boxShadow:
                      "0 8px 24px rgba(0,0,0,0.12)"
              }}
          >

              {
                  showAllCategories
                      ? "Réduire les catégories"
                      : "Voir toutes les catégories"
              }

          </Button>

      </div>

      {/* ========================= */}
      {/* EXPANDABLE SECTION */}
      {/* ========================= */}

      <div

          style={{

              maxHeight:
                  showAllCategories
                      ? 2000
                      : 0,

              overflow: "hidden",

              transition:
                  "all 0.5s ease",

              opacity:
                  showAllCategories
                      ? 1
                      : 0
          }}
      >
          </div>



      {
            showAllCategories && (
          <section className='assiganto-home-wrapper-2 py-4'>
              <div className='container-xxl'>
                  <div className='row'>
                      <div className='col-12'>
                          <div className='categories d-flex flex-wrap justify-content-between align-items-center'>

                              <div className='d-flex flex-column'>
                                  <div>
                                      <h6>Les fruits</h6>
                                      <Link className='farmers-link' to={`/catalog/category/FRUIT`}>
                                          31 producteurs
                                      </Link>
                                  </div>
                                  <img src='images/specimen-images/fruits.jpeg' className='img-fluid' alt='fruits' />
                              </div>
                              <div className='d-flex flex-column'>
                                  <div>
                                      <h6>Les herbes</h6>
                                      <Link className='farmers-link' to={`/catalog/category/HERB`}>
                                          27 producteurs
                                      </Link>
                                  </div>
                                  <img src='images/specimen-images/herbs.jpeg' className='img-fluid' alt='herbs' />
                              </div>
                              <div className='d-flex flex-column'>
                                  <div>
                                      <h6>Les Fleurs</h6>
                                      <Link className='farmers-link' to={`/catalog/category/FLOWER`}>
                                          6 producteurs
                                      </Link>
                                  </div>
                                  <img src='images/specimen-images/flowers.jpeg' className='img-fluid' alt='flowers' />
                              </div>
                              <div className='d-flex flex-column'>
                                  <div>
                                      <h6>Matières premières</h6>
                                      <Link className='farmers-link' to="/search?type=products&category=RAW_MATERIAL">
                                          11 producteurs
                                      </Link>
                                  </div>
                                  <img src='images/specimen-images/coton1.jpg'  className='img-fluid' alt='raw material' />
                              </div>

                              <div className='d-flex flex-column'>
                                  <div>
                                      <h6>Les tubercules</h6>
                                      <Link className='farmers-link' to={`/catalog/category/TUBER`}>
                                          27 producteurs
                                      </Link>
                                  </div>
                                  <img src='images/specimen-images/tubers.jpeg' className='img-fluid' alt='tubers' />
                              </div>

                          </div>
                      </div>
                  </div>
              </div>
          </section>
            )}

          {/* Nouvelle section QRCode */}
          <AppDownloadSection />
          <section className='assiganto-home-wrapper-2 py-4'>
              <div className='container-xxl'>
                  <div className='row'>
                      <div className='col-12'>
                          <div className='row gy-3'>
                              <div className='col-12 col-sm-6 col-md-4 col-lg-2 d-flex align-items-start gap-2'>
                                  <FiShoppingBag className='fs-3 flex-shrink-0'/>
                                  <div>
                                      <h6>Achat simplifié</h6>
                                      <p className='mb-0'>Partout au Togo</p>
                                  </div>
                              </div>
                              <div className='col-12 col-sm-6 col-md-4 col-lg-2 d-flex align-items-start gap-2'>
                                  <FiGift className='fs-3 flex-shrink-0'/>
                                  <div>
                                      <h6>Remise journalière</h6>
                                      <p className='mb-0'>Plus de 25%</p>
                                  </div>
                              </div>
                              <div className='col-12 col-sm-6 col-md-4 col-lg-2 d-flex align-items-start gap-2'>
                                  <GiPayMoney className='fs-3 flex-shrink-0'/>
                                  <div>
                                      <h6>Meilleurs prix</h6>
                                      <p className='mb-0'>Au prix des fermiers</p>
                                  </div>
                              </div>
                              <div className='col-12 col-sm-6 col-md-4 col-lg-2 d-flex align-items-start gap-2'>
                                  <MdSecurity className='fs-3 flex-shrink-0'/>
                                  <div>
                                      <h6>Paiement sécurisé</h6>
                                      <p className='mb-0'>100% sécurisé</p>
                                  </div>
                              </div>
                              <div className='col-12 col-sm-6 col-md-4 col-lg-2 d-flex align-items-start gap-2'>
                                  <FcOnlineSupport className='fs-3 flex-shrink-0'/>
                                  <div>
                                      <h6>Service client 24/7</h6>
                                      <p className='mb-0'>Aide d'un expert</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

    <section className="special-wrapper assiganto-home-wrapper-2 py-4">
      <div className='container-xxl'>
        <div className='row'>
          <div className=''>
            <div className='col-12'>
              <h3 className='section-heading'>Les offres du moment</h3>
            </div>
            <div className='row'>
              {meilleursVenteCardProps.map((item, index) => (
                   <MeilleursVentes {...item}/>))}
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className='featured-wrapper assiganto-home-wrapper-2 py-4'>
      <div className='container-xxl'>
        <div className='row'>
          <div className='col-12'>
            <h3 className='section-heading'>Disponible chez les détaillants</h3>
          </div>
          {productCardProps.map((item, index) => (

                <ProductCard {...item}/>

            ))}

        </div>
      </div>
    </section>
    
    <section className='famous-wrapper assiganto-home-wrapper-2 py-4'>
      <div className="container-xxl">
        <div className='row'>
          <div className='col-12 mb-3'>
            <h3 className='section-heading'>Équipements agricoles</h3>
          </div>

          {equipmentList.map((item, index) => (
            <div key={index} className='col-12 col-sm-6 col-md-4 col-lg-3 mb-4'>
              <EquipmentCard {...item} />
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className='marque-wrapper assiganto-home-wrapper-2 py-4'>
      <div className='container-xxl'>
        <div className='row'>
          <div className='col-12'>
            <div className='marquee-inner-wrapper card-wrapper'>
              <Marquee>
                <div className='mx-4 w-45'>
                <img src='images/payment-method-icons/floozNoColor.png' 
                   className='img-fluid' 
                   alt='famous' />
                </div>
                <div className='mx-4 w-45'>
                <img src='images/payment-method-icons/paypalNoColor.png' 
                   className='img-fluid' 
                   alt='famous' />
                </div>
                <div className='mx-4 w-45'>
                <img src='images/payment-method-icons/masterNoColor.png' 
                   className='img-fluid' 
                   alt='famous' />
                </div>
                <div className='mx-4 w-45'>
                <img src='images/payment-method-icons/ecoNoColor.png' 
                   className='img-fluid' 
                   alt='famous' />
                </div>
                <div className='mx-4 w-45'>
                <img src='images/payment-method-icons/worldNoColor.png' 
                   className='img-fluid' 
                   alt='famous' />
                </div>
              </Marquee>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className='blog-wrapper h-100 assiganto-home-wrapper-2 py-4'>
      <div className='container-xxl'>
        <div className='row'>
          <div className='col-12'>
            <h3 className='section-heading'>Actualités récentes</h3>
          </div>
          {blogCardProps.map((item, index) => (
            <div key={index} className='col-12 col-sm-6 col-md-4 col-lg-3 mb-4'>
              <BlogCard {...item} />
            </div>
          ))} 
        </div>
      </div>
    </section>

  </>
    
  )
}
export default Home